/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum SchemeColorEnum {
    PRIMARY = 'PRIMARY',
    PRIMARY_LIGHTER = 'PRIMARY_LIGHTER',
    PRIMARY_LIGHT = 'PRIMARY_LIGHT',
    SECONDARY = 'SECONDARY',
    SECONDARY_LIGHTER = 'SECONDARY_LIGHTER',
    SECONDARY_LIGHT = 'SECONDARY_LIGHT',
    TERTIARY = 'TERTIARY',
    TERTIARY_LIGHTER = 'TERTIARY_LIGHTER',
    TERTIARY_LIGHT = 'TERTIARY_LIGHT',
    GREY = 'GREY',
    TRANSPARENT = 'TRANSPARENT',
}